export default "__VITE_ASSET__GEXP2a$0__"